import styled from 'styled-components';
export const Panel = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0 88px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1270px;
  padding: 40px 20px;
  width: 100%;
`;
export const DescriptionWrapper = styled.div `
  max-width: 315px;
`;
export const Title = styled.h3 `
  font-size: ${({ theme }) => theme.fontSizesV2.title28.lg};
  font-weight: 600;
  line-height: 40px;
`;
export const Subtitle = styled.h4 `
  font-size: ${({ theme }) => theme.fontSizesV2.titleBody16.lg};
  font-weight: 600;
  color: ${({ theme }) => theme.colorsV2.font.textSecondary};
`;
export const Description = styled.p `
  margin-top: 28px;
  line-height: 20px;
`;
export const RouteImagesWrapper = styled.div `
  display: flex;
  gap: 0 16px;
`;
//# sourceMappingURL=LimitedEditionsPanel.styled.js.map